import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AbstractNoteService } from '../abstract-note.service';
import { Note } from '../../generated/interfaces';

@Component({
  selector: 'messaging-service-note-create',
  templateUrl: './note-create.component.html',
  styleUrls: ['./note-create.component.scss']
})
export class NoteCreateComponent implements OnInit {
  note = '';

  @Output()
  onSave = new EventEmitter<Note>();

  constructor(private noteService: AbstractNoteService) { }

  ngOnInit() {
  }

  save() {
    this.noteService.create(this.note).subscribe(note => this.onSave.emit(note));
  }
}
